import { OpenItemsType, SingleOpenItemDetailsType } from './openItemsTypes';

export const initialState: OpenItemsType = {
  fetching: false,
  statusCode: null,
  success: null,
  error: null,
  adminOpenItemList: [],
  sharedOpenItemsList: [],
  adminOpenItemSingle: {} as SingleOpenItemDetailsType,
  clientOpenItemList: [],
  openItemsCommentsList: [],
  commentsFetching: false,
  commentsSuccess: null,
  emailSuccess: null
}